export const categories = [
  "全部",
  "娱乐八卦",
  "影视综艺",
  "体育竞技",
  "科技数码",
  "社会话题",
  "网络热点",
];

export const heroStats = [
  { id: "s1", label: "今日新增话题", value: "128", unit: "个" },
  { id: "s2", label: "实时参与讨论", value: "36.5", unit: "万" },
  { id: "s3", label: "热评风向更新", value: "5", unit: "分钟/次" },
  { id: "s4", label: "收录观点立场", value: "正反双向", unit: "" },
];

export const featuredTopics = [
  {
    id: "f1",
    category: "影视综艺",
    title: "热播剧结局口碑两极，开放式收尾到底该不该给答案",
    summary:
      "收官当晚讨论量冲到全站前列，一部分观众认为留白才高级，另一部分直呼被骗了会员。围绕叙事诚意与观众期待，两派观点正面碰撞。",
    heat: "98.2万",
    comments: 6421,
    tag: "本站热榜 #1",
    image:
      "https://readdy.ai/api/search-image?query=moody%20editorial%20still%20life%20of%20a%20folded%20film%20strip%20on%20warm%20cream%20paper%20with%20muted%20crimson%20accent%20soft%20window%20light%20minimalist%20magazine%20aesthetic%20no%20text&width=900&height=640&seq=hl-feature-01&orientation=landscape&nocache=false",
  },
  {
    id: "f2",
    category: "网络热点",
    title: "短视频热门挑战被指模仿危险动作，平台该不该出手限流",
    summary:
      "一个跟拍挑战在几天内席卷全网，模仿者越来越多，安全问题随之浮出水面。创作者自由与平台责任之间的边界，再次被拉上台面讨论。",
    heat: "86.7万",
    comments: 5138,
    tag: "争议放送中",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20geometric%20composition%20with%20warm%20amber%20and%20cream%20blocks%20soft%20shadows%20editorial%20poster%20style%20minimal%20clean%20no%20text&width=900&height=640&seq=hl-feature-02&orientation=landscape&nocache=false",
  },
  {
    id: "f3",
    category: "科技数码",
    title: "新款旗舰定价再上探，网友为何这次褒贬格外激烈",
    summary:
      "发布会结束不到一小时，弹幕分成两个阵营：一派认为堆料值回票价，一派觉得溢价明显。价格与体验之间的那道线，到底由谁来划。",
    heat: "74.1万",
    comments: 3982,
    tag: "观点擂台精选",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20sleek%20matte%20device%20silhouette%20on%20warm%20beige%20backdrop%20with%20crimson%20edge%20light%20editorial%20product%20still%20life%20minimal%20no%20text&width=900&height=640&seq=hl-feature-03&orientation=landscape&nocache=false",
  },
];

export const allTopics = [
  {
    id: "t1",
    category: "娱乐八卦",
    title: "综艺剪辑争议：镜头分配是否公平引网友激辩",
    summary: "最新一期播出后，多位嘉宾的镜头时长被逐帧统计，公平性再度成为讨论焦点。",
    heat: "62.4万",
    comments: 3210,
    time: "2小时前",
  },
  {
    id: "t2",
    category: "影视综艺",
    title: "音乐类节目修音争议：现场实力与技术辅助的边界",
    summary: "有观众指出高音部分疑似过度修音，节目组暂未回应，讨论持续升温。",
    heat: "55.8万",
    comments: 2874,
    time: "4小时前",
  },
  {
    id: "t3",
    category: "体育竞技",
    title: "焦点战判罚尺度引发热议，慢镜头回放成辩论关键",
    summary: "终场前的一次判罚改变战局，赛后双方支持者就规则理解展开拉锯。",
    heat: "71.3万",
    comments: 4020,
    time: "1小时前",
  },
  {
    id: "t4",
    category: "科技数码",
    title: "AI 换脸特效走红，娱乐玩梗与冒用风险的界线在哪",
    summary: "低门槛换脸工具让玩梗变得简单，也让肖像与身份的边界变得更模糊。",
    heat: "48.9万",
    comments: 2517,
    time: "6小时前",
  },
  {
    id: "t5",
    category: "社会话题",
    title: "公共场合拍摄路人算不算侵权，法律边界被反复追问",
    summary: "一段街头拍摄视频走红后，被拍摄者发声，关于知情与同意的讨论展开。",
    heat: "44.2万",
    comments: 2380,
    time: "8小时前",
  },
  {
    id: "t6",
    category: "网络热点",
    title: "直播间价格战愈演愈烈，低价背后的质量疑虑谁来解",
    summary: "同样的商品在不同直播间差价悬殊，消费者开始关注低价是否等同低质。",
    heat: "58.6万",
    comments: 3092,
    time: "3小时前",
  },
  {
    id: "t7",
    category: "娱乐八卦",
    title: "组合解散传闻持续发酵，粉丝与路人观点正面碰撞",
    summary: "一条模糊的行程变动被解读为解散信号，讨论从猜测走向立场之争。",
    heat: "66.8万",
    comments: 3654,
    time: "5小时前",
  },
  {
    id: "t8",
    category: "体育竞技",
    title: "战队换人风波：成绩重要还是团队磨合更重要",
    summary: "赛季中途的人员调整引发争论，短期战绩与长期默契被放到天平两端。",
    heat: "52.1万",
    comments: 2760,
    time: "7小时前",
  },
  {
    id: "t9",
    category: "社会话题",
    title: "地铁让座视频被大量转发，道德讨论会变成网络审判吗",
    summary: "一段车厢内的冲突视频获百万转发，讨论从是非判断延伸到曝光尺度。",
    heat: "60.5万",
    comments: 3418,
    time: "9小时前",
  },
  {
    id: "t10",
    category: "影视综艺",
    title: "改编作品遭原著党质疑，还原度与再创作该如何平衡",
    summary: "热门改编剧上线后，原著与剧版差异成为讨论重点，两派各有坚持。",
    heat: "49.7万",
    comments: 2541,
    time: "10小时前",
  },
  {
    id: "t11",
    category: "科技数码",
    title: "智能设备订阅制是趋势还是套路，网友算了一笔账",
    summary: "按年订阅取代一次性买断的模式出现后，长期成本成为争论焦点。",
    heat: "41.3万",
    comments: 2188,
    time: "12小时前",
  },
  {
    id: "t12",
    category: "网络热点",
    title: "热搜词的诞生与消退：话题热度该如何被理性看待",
    summary: "有网友整理热搜词的完整生命周期，讨论热度与真实关注之间的关系。",
    heat: "45.9万",
    comments: 2436,
    time: "14小时前",
  },
];

export const debates = [
  {
    id: "d1",
    label: "综艺剪辑争议",
    question: "镜头分配不均，是节目安排还是刻意引导",
    pro: {
      title: "认为确有不公",
      points: [
        "逐帧统计显示个别嘉宾镜头不足同伴三分之一",
        "剪辑节奏明显偏向制造话题，而非呈现过程",
        "观众付费观看，理应看到相对均衡的内容",
      ],
    },
    con: {
      title: "认为属过度解读",
      points: [
        "综艺剪辑服务于整体叙事，难以做到绝对平均",
        "镜头多少受现场表现影响，不能只用时长衡量",
        "把每一秒都当成证据，讨论容易失去重点",
      ],
    },
    comments: [
      {
        id: "c1",
        user: "看片不吐皮",
        stance: "pro",
        text: "统计摆在那儿，不是情绪问题。至少得给个解释，而不是当没看见。",
        likes: 2861,
      },
      {
        id: "c2",
        user: "冷静吃瓜派",
        stance: "con",
        text: "剪一分钟都要吵一次，那综艺别做了。先把完整版放出来再评价更稳。",
        likes: 1934,
      },
      {
        id: "c3",
        user: "周末追综",
        stance: "pro",
        text: "我两边都看，感受就是有一位全程在当背景板，观感确实差。",
        likes: 1502,
      },
      {
        id: "c4",
        user: "路人甲观察局",
        stance: "con",
        text: "把时长当唯一标准就偏了，现场效果和互动才是剪辑的核心依据。",
        likes: 1188,
      },
    ],
  },
  {
    id: "d2",
    label: "热播剧结局",
    question: "开放式结局是高级留白，还是敷衍收场",
    pro: {
      title: "支持留白",
      points: [
        "结局留白让角色命运保留想象空间，回味更久",
        "现实本就少有标准答案，模糊处理更接近真实",
        "讨论热度本身说明结局达到了引发思考的目的",
      ],
    },
    con: {
      title: "认为敷衍",
      points: [
        "前期埋了大量线索，最后一条都没兑现",
        "关键矛盾草草收场，更像是为续集留口子",
        "观众投入了整季时间，有权得到一个完整交代",
      ],
    },
    comments: [
      {
        id: "c5",
        user: "追剧到天亮",
        stance: "con",
        text: "看完最后一集血压上来了，前面铺那么多线，结果全靠观众自己脑补。",
        likes: 3217,
      },
      {
        id: "c6",
        user: "留白爱好者",
        stance: "pro",
        text: "我就喜欢这种结尾，第二天还在想角色后来怎么样了，这才是好剧。",
        likes: 2088,
      },
      {
        id: "c7",
        user: "剧评小透明",
        stance: "con",
        text: "留白和写不完是两回事，前者有设计感，后者一眼能看出来是赶工。",
        likes: 1746,
      },
      {
        id: "c8",
        user: "半夜刷剧人",
        stance: "pro",
        text: "非要所有事都交代清楚，那不叫结局，叫说明书。",
        likes: 1320,
      },
    ],
  },
  {
    id: "d3",
    label: "危险挑战限流",
    question: "热门挑战涉及风险动作，平台该不该主动限流",
    pro: {
      title: "支持限流",
      points: [
        "模仿成本极低，风险动作容易被未成年人照搬",
        "平台拥有分发权，也应当承担相应的引导责任",
        "给出风险提示并降低推荐权重，是相对温和的手段",
      ],
    },
    con: {
      title: "反对一刀切",
      points: [
        "限流标准模糊，容易误伤正常创作内容",
        "风险教育比简单下架更能解决根本问题",
        "创作者应有表达空间，判断不该由算法单方面完成",
      ],
    },
    comments: [
      {
        id: "c9",
        user: "家里有娃",
        stance: "pro",
        text: "支持限流。孩子刷到就跟着做，家长根本来不及拦，平台该有底线。",
        likes: 2740,
      },
      {
        id: "c10",
        user: "内容从业者",
        stance: "con",
        text: "怕的不是限流，是标准不透明。今天限这个，明天可能就轮到正常内容。",
        likes: 2210,
      },
      {
        id: "c11",
        user: "理性看客",
        stance: "pro",
        text: "加风险提示、降推荐权重，这种处理方式我觉得挺合理的。",
        likes: 1455,
      },
      {
        id: "c12",
        user: "拍视频的",
        stance: "con",
        text: "与其一刀切，不如把安全提示做足，让观众自己判断。",
        likes: 1093,
      },
    ],
  },
];

export const hotRanking = [
  { rank: 1, title: "热播剧结局口碑两极，开放式收尾该不该给答案", heat: "98.2万", trend: "up" },
  { rank: 2, title: "短视频危险挑战被指模仿，平台该不该限流", heat: "86.7万", trend: "up" },
  { rank: 3, title: "焦点战判罚尺度引发热议，慢镜头成辩论关键", heat: "71.3万", trend: "down" },
  { rank: 4, title: "组合解散传闻持续发酵，粉丝与路人观点碰撞", heat: "66.8万", trend: "up" },
  { rank: 5, title: "综艺剪辑争议：镜头分配是否公平引网友激辩", heat: "62.4万", trend: "flat" },
  { rank: 6, title: "地铁让座视频被大量转发，道德讨论会变网络审判吗", heat: "60.5万", trend: "up" },
  { rank: 7, title: "直播间价格战愈演愈烈，低价背后的质量疑虑", heat: "58.6万", trend: "down" },
  { rank: 8, title: "音乐类节目修音争议：现场实力与技术辅助的边界", heat: "55.8万", trend: "flat" },
];

export const faqs = [
  {
    id: "q1",
    q: "黑料看点里的内容都是真实发生的吗？",
    a: "站内话题与评论均为网友讨论观点的汇总呈现，用于展示舆论风向与不同立场，不构成对任何具体人事的事实认定，请以理性视角阅读，切勿当作结论传播。",
  },
  {
    id: "q2",
    q: "怎样才能参与话题讨论？",
    a: "你可以在话题广场挑选感兴趣的话题，进入对应讨论区表达观点；也可以订阅本站热点话题提醒，第一时间收到新话题与热评更新通知。",
  },
  {
    id: "q3",
    q: "为什么同一个话题会出现完全相反的两种观点？",
    a: "这正是我们呈现讨论的方式。观点擂台会把支持与反对两派的核心理由并列展示，帮助你同时看到论据，而不是只接收单一立场。",
  },
  {
    id: "q4",
    q: "站内的热度数据是如何统计的？",
    a: "热度综合了讨论量、评论增长速度和观点分布等维度，按固定频率更新，用于反映话题受关注的程度，仅作参考，不代表任何官方评价。",
  },
  {
    id: "q5",
    q: "看到不实或过激的内容怎么办？",
    a: "每条内容旁都提供反馈入口。我们鼓励用户举报明显不实、涉及隐私或攻击性的内容，审核团队会按社区规范处理，维护理性讨论的环境。",
  },
  {
    id: "q6",
    q: "可以推荐话题或者投稿观点吗？",
    a: "当然可以。通过页面底部的订阅与联系表单留言，说明你想讨论的话题或想补充的观点，编辑团队会评估后安排展示。",
  },
];

export const testimonials = [
  {
    id: "r1",
    name: "阿澈",
    role: "资深吃瓜群众",
    text: "最喜欢这种把正反观点并排放在一起的呈现方式，看完整个人都冷静了不少，不会一上来就被带节奏。",
  },
  {
    id: "r2",
    name: "小满每天看",
    role: "通勤用户",
    text: "地铁上刷十分钟就能知道今天大家在聊什么，热度榜的排序很直观，比在各个平台来回切换省事多了。",
  },
  {
    id: "r3",
    name: "老周评热点",
    role: "内容爱好者",
    text: "评论区的观点标签做得不错，一眼能分出立场，讨论起来效率高，也不容易误会别人在说什么。",
  },
  {
    id: "r4",
    name: "橙子不加冰",
    role: "新用户",
    text: "页面干净，没有乱七八糟的弹窗。订阅了话题提醒之后，感兴趣的内容基本没漏过。",
  },
];

export const principles = [
  {
    id: "p1",
    icon: "ri-scales-3-line",
    title: "多角度呈现",
    text: "同一个话题，支持与反对的理由同等重要，我们把两边的论据都摆上台面。",
  },
  {
    id: "p2",
    icon: "ri-time-line",
    title: "实时跟进",
    text: "按固定频率刷新讨论量与观点分布，让舆论风向的变化看得见。",
  },
  {
    id: "p3",
    icon: "ri-shield-check-line",
    title: "倡导理性",
    text: "拒绝人身攻击与隐私曝光，鼓励就事论事、有据可依地表达观点。",
  },
  {
    id: "p4",
    icon: "ri-user-voice-line",
    title: "尊重立场",
    text: "立场不同不意味着对立，我们为每一种有依据的声音保留表达空间。",
  },
];